// Textos da CNH (27/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.cnh.titulo': 'CNH',
    'dp.cnh.situacao.vencida': 'Vencida',
    'dp.cnh.situacao.vence_30': 'Vence em {{cnhCriticaDias}} dias',
    'dp.cnh.situacao.vence_60': 'Vence em {{cnhAvisoDias}} dias',
    'dp.cnh.situacao.em_dia': 'Em dia',
    'dp.cnh.situacao.sem_vencimento': 'Sem vencimento',
    'dp.cnh.kpi.escaladosVencida': 'Escalados com CNH vencida',
    'dp.cnh.venceEm': 'Validade {{data}}',
    'dp.cnh.escaladoHoje': 'Escalado hoje',
    'dp.cnh.escaladoAmanha': 'Escalado amanhã',
    'dp.cnh.col.vencimento': 'Vencimento',
    'dp.cnh.col.escala': 'Escala',
    'dp.cnh.atualizar': 'Vencimento',
    'dp.cnh.categoria': 'Função',
    'dp.cnh.categoria.driver': 'Motoristas',
    'dp.cnh.categoria.operator': 'Operadores',
    'dp.cnh.vencimentoTitulo': 'CNH de {{nome}}',
    'dp.cnh.vencimentoAtual': 'Validade registrada: {{data}}.',
    'dp.cnh.semVencimento': 'Ainda sem data de validade.',
    'dp.cnh.novoVencimento': 'Nova validade',
    'dp.cnh.cobrancaTitulo': 'Cobrar a CNH de {{nome}}',
    'dp.cnh.cobrancaTexto': 'Cobrança da CNH renovada pelo WhatsApp.',
    'dp.cnh.importarTitulo': 'Importar o controle de CNH',
    'dp.cnh.importarExplica': 'A planilha de controle de vencimento da CNH do DP. A data vai para o cadastro da pessoa; o texto no lugar da data e a observação viram anotação. A chave que não está no Hub é procurada pelo CPF.',
    'dp.cnh.carga.comVencimento': 'Com data de validade',
    'dp.cnh.carga.texto': 'Com texto no lugar da data',
    'dp.cnh.carga.pelaCpf': 'Achadas pelo CPF',
    'dp.cnh.carga.anotacoes': 'Anotações novas',
    // O documento da CNH (31/10/2026).
    'dp.cnh.col.documento': 'Documento',
    'dp.cnh.documento.todos': 'Todos',
    'dp.cnh.anexar': 'Anexar',
    'dp.cnh.anexarTitulo': 'Anexar a CNH de {{nome}}',
    'dp.cnh.anexarExplica': 'Envie o PDF do app CNH do Brasil ou a foto do documento e informe o que está nele. A validade vai para o cadastro da pessoa; o documento anterior fica no histórico.',
    'dp.cnh.arquivo': 'Escolher o arquivo',
    'dp.cnh.arquivoRegra': 'PDF, JPG ou PNG, até 5 MB.',
    'dp.cnh.semArquivo': 'Escolha o arquivo da CNH.',
    'dp.cnh.enviar': 'Enviar',
    'dp.cnh.enviado': 'Documento enviado.',
    'dp.cnh.numero': 'Número de registro',
    'dp.cnh.categoriaCnh': 'Categoria da CNH',
    'dp.cnh.validade': 'Validade lida no documento',
    'dp.cnh.emissao': 'Emissão',
    'dp.cnh.primeiraHabilitacao': 'Primeira habilitação',
    'dp.cnh.ear': 'EAR',
    'dp.cnh.earLongo': 'Exerce atividade remunerada',
    'dp.cnh.ear.sim': 'Sim',
    'dp.cnh.ear.nao': 'Não',
    'dp.cnh.ear.semInformacao': 'Não informado',
    'dp.cnh.comEar': 'Com EAR',
    'dp.cnh.semEar': 'Sem EAR',
    'dp.cnh.documentoDe': 'Documento de {{data}}',
    'dp.cnh.semDocumento': 'Sem documento',
    'dp.cnh.abrirDocumento': 'Abrir o documento',
    'dp.cnh.detalhe': 'Detalhe',
    'dp.cnh.validadeEsperada': 'Validade esperada pela idade',
    'dp.cnh.validadeAlem': 'Validade acima da esperada pela idade',
    'dp.cnh.validadeAlemExplica': 'Pela idade na emissão, o exame vale até {{data}}. Confira o documento.',
    'dp.cnh.historico': 'Documentos enviados',
    'dp.cnh.historicoVazio': 'Nenhum documento enviado.',
    'dp.cnh.atual': 'Atual',
    'dp.cnh.validadeInformada': 'Validade {{data}}',
    'dp.cnh.enviadoPor': 'Enviado por {{nome}}',
  },
  en: {
    'dp.cnh.titulo': 'Driver\'s license',
    'dp.cnh.situacao.vencida': 'Expired',
    'dp.cnh.situacao.vence_30': 'Expires within {{cnhCriticaDias}} days',
    'dp.cnh.situacao.vence_60': 'Expires within {{cnhAvisoDias}} days',
    'dp.cnh.situacao.em_dia': 'Valid',
    'dp.cnh.situacao.sem_vencimento': 'No expiration',
    'dp.cnh.kpi.escaladosVencida': 'Scheduled with expired license',
    'dp.cnh.venceEm': 'Valid until {{data}}',
    'dp.cnh.escaladoHoje': 'Scheduled today',
    'dp.cnh.escaladoAmanha': 'Scheduled tomorrow',
    'dp.cnh.col.vencimento': 'Expiration',
    'dp.cnh.col.escala': 'Schedule',
    'dp.cnh.atualizar': 'Expiration',
    'dp.cnh.categoria': 'Role',
    'dp.cnh.categoria.driver': 'Drivers',
    'dp.cnh.categoria.operator': 'Operators',
    'dp.cnh.vencimentoTitulo': 'License of {{nome}}',
    'dp.cnh.vencimentoAtual': 'Recorded validity: {{data}}.',
    'dp.cnh.semVencimento': 'No validity date yet.',
    'dp.cnh.novoVencimento': 'New validity',
    'dp.cnh.cobrancaTitulo': 'Ask {{nome}} for the license',
    'dp.cnh.cobrancaTexto': 'Asked for the renewed license on WhatsApp.',
    'dp.cnh.importarTitulo': 'Import the license control',
    'dp.cnh.importarExplica': 'The HR license expiration spreadsheet. The date goes to the person record; text in place of the date and the note become annotations. A key not found in the Hub is looked up by ID number.',
    'dp.cnh.carga.comVencimento': 'With validity date',
    'dp.cnh.carga.texto': 'With text instead of a date',
    'dp.cnh.carga.pelaCpf': 'Found by ID number',
    'dp.cnh.carga.anotacoes': 'New annotations',
    'dp.cnh.col.documento': 'Document',
    'dp.cnh.documento.todos': 'All',
    'dp.cnh.anexar': 'Attach',
    'dp.cnh.anexarTitulo': 'Attach the license of {{nome}}',
    'dp.cnh.anexarExplica': 'Upload the PDF from the official app or a photo of the document and enter what it says. The validity goes to the person record; the previous document stays in the history.',
    'dp.cnh.arquivo': 'Choose the file',
    'dp.cnh.arquivoRegra': 'PDF, JPG or PNG, up to 5 MB.',
    'dp.cnh.semArquivo': 'Choose the license file.',
    'dp.cnh.enviar': 'Send',
    'dp.cnh.enviado': 'Document sent.',
    'dp.cnh.numero': 'Registration number',
    'dp.cnh.categoriaCnh': 'License category',
    'dp.cnh.validade': 'Validity read on the document',
    'dp.cnh.emissao': 'Issued on',
    'dp.cnh.primeiraHabilitacao': 'First license',
    'dp.cnh.ear': 'EAR',
    'dp.cnh.earLongo': 'Drives for a living',
    'dp.cnh.ear.sim': 'Yes',
    'dp.cnh.ear.nao': 'No',
    'dp.cnh.ear.semInformacao': 'Not informed',
    'dp.cnh.comEar': 'With EAR',
    'dp.cnh.semEar': 'Without EAR',
    'dp.cnh.documentoDe': 'Document from {{data}}',
    'dp.cnh.semDocumento': 'No document',
    'dp.cnh.abrirDocumento': 'Open the document',
    'dp.cnh.detalhe': 'Details',
    'dp.cnh.validadeEsperada': 'Validity expected by age',
    'dp.cnh.validadeAlem': 'Validity beyond the one expected by age',
    'dp.cnh.validadeAlemExplica': 'By the age at issue, the exam is valid until {{data}}. Check the document.',
    'dp.cnh.historico': 'Documents sent',
    'dp.cnh.historicoVazio': 'No document sent.',
    'dp.cnh.atual': 'Current',
    'dp.cnh.validadeInformada': 'Valid until {{data}}',
    'dp.cnh.enviadoPor': 'Sent by {{nome}}',
  },
  es: {
    'dp.cnh.titulo': 'Licencia de conducir',
    'dp.cnh.situacao.vencida': 'Vencida',
    'dp.cnh.situacao.vence_30': 'Vence en {{cnhCriticaDias}} días',
    'dp.cnh.situacao.vence_60': 'Vence en {{cnhAvisoDias}} días',
    'dp.cnh.situacao.em_dia': 'Al día',
    'dp.cnh.situacao.sem_vencimento': 'Sin vencimiento',
    'dp.cnh.kpi.escaladosVencida': 'Escalados con licencia vencida',
    'dp.cnh.venceEm': 'Validez {{data}}',
    'dp.cnh.escaladoHoje': 'Escalado hoy',
    'dp.cnh.escaladoAmanha': 'Escalado mañana',
    'dp.cnh.col.vencimento': 'Vencimiento',
    'dp.cnh.col.escala': 'Escala',
    'dp.cnh.atualizar': 'Vencimiento',
    'dp.cnh.categoria': 'Función',
    'dp.cnh.categoria.driver': 'Conductores',
    'dp.cnh.categoria.operator': 'Operadores',
    'dp.cnh.vencimentoTitulo': 'Licencia de {{nome}}',
    'dp.cnh.vencimentoAtual': 'Validez registrada: {{data}}.',
    'dp.cnh.semVencimento': 'Aún sin fecha de validez.',
    'dp.cnh.novoVencimento': 'Nueva validez',
    'dp.cnh.cobrancaTitulo': 'Cobrar la licencia de {{nome}}',
    'dp.cnh.cobrancaTexto': 'Cobro de la licencia renovada por WhatsApp.',
    'dp.cnh.importarTitulo': 'Importar el control de licencias',
    'dp.cnh.importarExplica': 'La planilla de control de vencimiento de licencias del DP. La fecha va al registro de la persona; el texto en lugar de la fecha y la observación se vuelven anotación. La clave que no está en el Hub se busca por el documento.',
    'dp.cnh.carga.comVencimento': 'Con fecha de validez',
    'dp.cnh.carga.texto': 'Con texto en lugar de la fecha',
    'dp.cnh.carga.pelaCpf': 'Encontradas por el documento',
    'dp.cnh.carga.anotacoes': 'Anotaciones nuevas',
    'dp.cnh.col.documento': 'Documento',
    'dp.cnh.documento.todos': 'Todos',
    'dp.cnh.anexar': 'Adjuntar',
    'dp.cnh.anexarTitulo': 'Adjuntar la licencia de {{nome}}',
    'dp.cnh.anexarExplica': 'Envíe el PDF de la app oficial o la foto del documento e informe lo que dice. La validez va al registro de la persona; el documento anterior queda en el historial.',
    'dp.cnh.arquivo': 'Elegir el archivo',
    'dp.cnh.arquivoRegra': 'PDF, JPG o PNG, hasta 5 MB.',
    'dp.cnh.semArquivo': 'Elija el archivo de la licencia.',
    'dp.cnh.enviar': 'Enviar',
    'dp.cnh.enviado': 'Documento enviado.',
    'dp.cnh.numero': 'Número de registro',
    'dp.cnh.categoriaCnh': 'Categoría de la licencia',
    'dp.cnh.validade': 'Validez leída en el documento',
    'dp.cnh.emissao': 'Emisión',
    'dp.cnh.primeiraHabilitacao': 'Primera licencia',
    'dp.cnh.ear': 'EAR',
    'dp.cnh.earLongo': 'Ejerce actividad remunerada',
    'dp.cnh.ear.sim': 'Sí',
    'dp.cnh.ear.nao': 'No',
    'dp.cnh.ear.semInformacao': 'No informado',
    'dp.cnh.comEar': 'Con EAR',
    'dp.cnh.semEar': 'Sin EAR',
    'dp.cnh.documentoDe': 'Documento del {{data}}',
    'dp.cnh.semDocumento': 'Sin documento',
    'dp.cnh.abrirDocumento': 'Abrir el documento',
    'dp.cnh.detalhe': 'Detalle',
    'dp.cnh.validadeEsperada': 'Validez esperada por la edad',
    'dp.cnh.validadeAlem': 'Validez mayor que la esperada por la edad',
    'dp.cnh.validadeAlemExplica': 'Por la edad en la emisión, el examen vale hasta {{data}}. Revise el documento.',
    'dp.cnh.historico': 'Documentos enviados',
    'dp.cnh.historicoVazio': 'Ningún documento enviado.',
    'dp.cnh.atual': 'Actual',
    'dp.cnh.validadeInformada': 'Validez {{data}}',
    'dp.cnh.enviadoPor': 'Enviado por {{nome}}',
  },
}
